import { jsx } from 'react/jsx-runtime';
import React__default, { useContext, useState, useCallback } from 'react';
const MessageBoundaryContext = React__default.createContext({
  messages: [],
  addMessage: () => {},
  removeMessage: () => {},
  clearMessages: () => {}
});
const useMessageBoundary = () => {
  const {
    messages,
    addMessage,
    removeMessage,
    clearMessages
  } = useContext(MessageBoundaryContext);
  return {
    messages,
    addMessage,
    removeMessage,
    clearMessages
  };
};
const MessageBoundaryProvider = _ref => {
  let {
    children
  } = _ref;
  const [messages, setMessages] = useState([]);
  const removeMessage = useCallback(m => {
    setMessages(messages2 => messages2.filter(x => x.id !== m.id));
  }, []);
  const addMessage = useCallback(m => {
    m.id = m.id || /* @__PURE__ */new Date().getTime();
    setMessages(messages2 => [...messages2, m]);
  }, []);
  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);
  const contextValue = {
    messages,
    addMessage,
    removeMessage,
    clearMessages
  };
  return /* @__PURE__ */jsx(MessageBoundaryContext.Provider, {
    value: contextValue,
    children
  });
};
export { MessageBoundaryContext, MessageBoundaryProvider as default, useMessageBoundary };